import { VI_PRICE_MAP } from "./constants";
import { localeFromPath } from "./localePaths";

/** Localized display string for a USD list price (e.g. "$9.99" → VND map or passthrough). */
export function displayPrice(usdPrice, locale) {
  const resolved =
    locale || (typeof window !== "undefined" ? localeFromPath(window.location.pathname) : "en");
  if (resolved === "vi") return VI_PRICE_MAP[usdPrice] || usdPrice;
  return usdPrice;
}
